<script setup>
// The footnote every view's one "free*" claim points to (C5-9, redone 27 Sep
// 2026). It sits INSIDE the line it annotates and inherits its size and
// colour, so it is never larger or louder than that line.
import {COMMISSION_NOTE} from '~/utils/commissionNote';
</script>

<template>
  <span class="commission-note">{{ COMMISSION_NOTE }}</span>
</template>

<style scoped>
.commission-note {
  display: block;
  margin-top: 6px;
  font-size: inherit;
  line-height: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  text-transform: none;
  color: inherit;
}
</style>
